import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=30235566&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=30235566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30235566",
  null
  
)

export default component.exports